import BreadCrumb from "../../../components/BreadCrumb";
import Button from "../../../components/Button";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { Grid } from "@mui/material";
import NoRecentUsers from "../../../assets/images/nofeatureicons/norecentuser.svg";
import Table from "../../../components/Table/Table";
import useStyles from "../styles";
import { TableSearch } from "../../../components/Table/TableActions";
import { Gender } from "../../../utils/DropDown";
import NoData from "../../dashboard/components/NotFoundCard/NoData";
import { toast } from "react-toastify";
import Modal from "../../../components/Modal";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Select from "react-select";
import { Icon } from "@iconify/react";
import Layout from "../../../components/Layout";
import { useParams, useNavigate } from "react-router-dom";
import useValidator from "../../../hooks/useValidator";
import { useUserState } from "../../../context/UserContext";
import useWindowSize from "../../../hooks/useWindow";
import PageLoader from "../../../components/PageLoader";

// const HOSTEL_ENDPOINT = "api/v1";
const EMPLOYEES_ENDPOINT = "api/v1/employees";
const STUDENT_ENDPOINT = "/api/v1/students";
const GET_ROOM_ENDPOINT = "/api/v1/hostel-management/hostel-room/";
const ALL_HOSTEL_ENDPOINT = "/api/v1/hostel-management/all-hostels";
const UPDATE_ROOM = "/api/v1/hostel-management/hostel-room/";
const ALLOCATE_ENDPOINT = "/api/v1/hostel-management/hostels/allocate";
const HOSTEL_ROOM = "/api/v1/hostel-management/hostel-rooms/";

const AdminHostel = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { id } = useParams();
  const { userRole } = useUserState();
  const [hostelRoom, setHostelRoom] = useState([]);
  const [studentInRoom, setStudentInRoom] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [isAllocating, setISAllocating] = useState(false);
  const [itemModal, setItemModal] = useState(false);
  const [isRoomEditing, setIsRoomEditing] = useState(false);
  const [editRoomModal, setEditRoomModal] = useState(false);
  const [allocate, setAllocate] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteRoomModal, setDeleteRoomModal] = useState(false);
  const [removeStudentModal, setRemoveStudentModal] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);
  const [allHostels, setAllHostels] = useState([]);
  const [currentRow, setCurrentRow] = useState({});
  const [searchResult, setSearchResult] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [studentData, setStudentsData] = useState([]);
  const [allHostelRoom, setAllHostelRoom] = useState([]);
  const [editRoomValidator, showEditRoomValidator] = useValidator();
  const [allocateHostelValidator, showAllocateHostelValidator] = useValidator();
  const [itemRow, setItemRow] = useState({});
  const width = useWindowSize();
  const mobile = width < 600;

  const [edithostelRoomForm, setEditHostelRoomForm] = useState({
    hostel_id: id,
    room_number: "",
    capacity: ""
  });

  const [allocations, setAllocations] = useState(
    {
      hostel_id: hostelRoom?.hostel_id,
      students: [],
      room_id: id,
      allocated_by: userRole?.id
    }
  );

  const handleCloseDeleteRoom = () => {
    setCurrentRow({});
    setDeleteRoomModal(false);
  };
  const handleCloseRemoveStudent = () => {
    setItemRow({});
    setRemoveStudentModal(false);
  };

  const handleRemoveStudentRow = (row) => {
    setItemRow(row);
    setRemoveStudentModal(true);
  };

  const actions = [
    { label: "Inventory", icon: "mdi:clipboard-list-outline" },
    { label: "Messages", icon: "mdi:message-text-outline" },
    { label: "Add Student", icon: "mdi:account-plus-outline" }
  ];

  const handleAllocateHostelChange = (e) => {
    const { name, value } = e.target;

    // If hostel_id changes, fetch hostel rooms
    // if (name === "hostel_id" && value) {
    //   getAllHostelRoom(value);
    // }
    // Update the allocations state
    setAllocations((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleOpenAllocateModal = () => {
    setAllocate(!allocate);
  };

  const handleClick = (label) => {
    if (label === "Inventory") {
      if (hostelRoom?.hostel_id) {
        navigate(`/hostel/inventory/${hostelRoom?.hostel_id}`);
      }
    } else if (label === "Messages") {
      navigate(`/hostel/messages/${hostelRoom?.hostel_id}`);
    } else if (label === "Add Student") {
      handleOpenAllocateModal();
    }
  };

  const handleCloseEditModal = () => {
    setCurrentRow({});
    setEditRoomModal(false);
  };

  const handleDeleteRoomRow = (row) => {
    setCurrentRow(row);
    setDeleteRoomModal(true);
  };

  const handleEditRoomChange = (e) => {
    const { name, value } = e.target;
    setEditHostelRoomForm({ ...edithostelRoomForm, [name]: value });
  };

  const handleOpenItemMOdal = () => {
    setItemModal(!itemModal);
  };

  const handleEditRoomRow = (row) => {
    setCurrentRow(row);
    setEditHostelRoomForm({
      ...edithostelRoomForm,
      room_number: row?.room_number,
      capacity: row?.capacity
    });
    setEditRoomModal(true);
  };

  const handleCloseAllocateModal = () => {
    setAllocate(false);
    setAllocations({
      hostel_id: hostelRoom?.hostel_id,
      students: [],
      room_id: id,
      allocated_by: userRole?.id
    });
  };

  const recentUser = [
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Student Name</p>}
          {row?.full_name || "--/--"}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Class</p>}
          {row?.class || "--/--"}
        </>
      )
    },
    {
      name: "Student Email",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Student Email</p>}
          {row?.email || "--/--"}
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row, index) => (
        <div key={index} className="table-action-container">
          <button
            className="table-action-icon"
            onClick={() => navigate(`/users/students/${row?.student_id}`)}
          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
          {/* <button
            className="table-action-icon"
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button> */}
          <button
            className="table-action-icon"
            onClick={() => handleRemoveStudentRow(row)}
          >
            <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
          </button>
        </div>
      )
    }
  ];

  /**
       * Fetches all classes in the school.
       */
  const getAllHostels = () => {
    httprequest.get(ALL_HOSTEL_ENDPOINT).then((res) => {
      setAllHostels(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
       * Fetches all classes in the school.
       */
  const getAllHostelRoom = (hostel_id) => {
    httprequest.get(`${HOSTEL_ROOM}${hostel_id}`).then((res) => {
      setAllHostelRoom(res?.data?.rooms);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
   * Fetches all students and separates them into active/inactive categories.
   * Also handles loading state and error toasts.
   */
  const getAllStudents = () => {
    httprequest.get(STUDENT_ENDPOINT).then((res) => {
      setStudentsData(res?.data?.data?.filter((active_stn) => active_stn?.is_active === true)?.map((stdn) => {
        return {
          label: `${stdn?.student?.last_name} ${stdn?.student?.first_name}`,
          value: stdn?.student?.id
        };
      }));
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  /**
       * Fetches Hostel by ID
       */
  const getAllRoombyID = () => {
    setPageLoading(true);
    httprequest.get(`${GET_ROOM_ENDPOINT}${id}`).then((res) => {
      setHostelRoom(res?.data?.data);
      setSearchResult(res?.data?.students);
      setStudentInRoom(res?.data?.students);
      setPageLoading(false);
    }).catch((err) => {
      setPageLoading(false);
      toast.error(err?.response?.data);
    });
  };

  const handleAllocateHostel = () => {
    if (allocateHostelValidator.allValid()) {
      setISAllocating(true);
      const payload = {
        allocate_students: [allocations]
      };
      httprequest.post(ALLOCATE_ENDPOINT, payload).then((res) => {
        setISAllocating(false);
        toast.success(res?.data?.message);
        handleCloseAllocateModal();
        getAllRoombyID();
      }).catch((err) => {
        setISAllocating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showAllocateHostelValidator(true);
    }
  };

  const handleEditRoom = () => {
    if (editRoomValidator.allValid()) {
      setIsRoomEditing(true);
      httprequest.patch(`${UPDATE_ROOM}${currentRow?.id}`, edithostelRoomForm).then((res) => {
        setIsRoomEditing(false);
        toast.success(res?.data?.message);
        handleCloseEditModal();
        getAllHostels();
        getAllRoombyID();
      }).catch((err) => {
        setIsRoomEditing(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showEditRoomValidator(true);
    }
  };

  const handleDeleteHostel = () => {
    setIsDeleting(true);
    httprequest.delete(`${UPDATE_ROOM}${currentRow?.id}`).then((res) => {
      setIsDeleting(false);
      toast.success(res?.data?.message);
      getAllHostels();
      setDeleteRoomModal(!deleteRoomModal);
      setCurrentRow({});
      setTimeout(() => {
        navigate("/hostel");
      }, 1000);
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };
  const handleRemoveStudent = () => {
    setIsRemoving(true);
    httprequest.delete(`${HOSTEL_ROOM}${itemRow?.id}/student/${itemRow?.student_id}`).then((res) => {
      setIsRemoving(false);
      toast.success(res?.data?.message);
      handleCloseRemoveStudent();
      getAllRoombyID();
    }).catch((err) => {
      setIsRemoving(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const handleStudentChange = (selectedOptions) => {
    const studentIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
    setAllocations((prev) => ({
      ...prev,
      students: studentIds
    }));
  };

  /**
   * Fetches employee data from the server based on the selected `value` (e.g., staff status).
   * Updates the employee state and loading state accordingly.
   *
   * @function getEmployeeData
   */
  const getEmployeeData = () => {
    httprequest.get(`${EMPLOYEES_ENDPOINT}`).then((res) => {
      setEmployeesData(res?.data?.data?.employees);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  useEffect(() => {
    getEmployeeData();
    getAllStudents();
    getAllRoombyID();
    getAllHostels();
  }, []);

  useEffect(() => {
    if (hostelRoom?.hostel_id) {
      getAllHostelRoom(hostelRoom?.hostel_id);
    }
  }, [hostelRoom?.hostel_id]);

  useEffect(() => {
    if (hostelRoom?.hostel_id) {
      setAllocations((prev) => ({
        ...prev,
        hostel_id: hostelRoom.hostel_id
      }));
    }
  }, [hostelRoom?.hostel_id]);

  // --| Filter Inventory table using name, email and class
  const handleSearchInventory = (e) => {
    const { value } = e.target;

    const valArray = value?.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = studentInRoom?.filter((data) => valArray?.every(
      (word) => data?.full_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                    data?.class
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                    data?.email
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                      data?.status
                        ?.toLowerCase()
                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one={`/hostel/${hostelRoom?.hostel_id}`}
              link_one_name="Hostel Management"
              active={hostelRoom?.hostel_name || "Room Information"}
              description="See details of students in a hostel room"
            />
          </div>
          <div>
          </div>
        </div>
        <div className="page-content margin-top-16">
          <div className={classes.flexx}>
            <div className={classes.hosteldetail}>
              <h2>{hostelRoom?.hostel_name}</h2>
              <div className="flex gap-10">
                <p>Room {hostelRoom?.room_number}</p>
                <div>
                  <button
                    className="table-action-icon"
                    onClick={() => handleEditRoomRow(hostelRoom)}
                  >
                    <Icon icon="heroicons:pencil-square-solid" />
                  </button>
                  <button
                    className="table-action-icon"
                    onClick={() => handleDeleteRoomRow(hostelRoom)}
                  >
                    <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
                  </button>
                </div>
              </div>
            </div>
            <div className={classes.threecontainer}>
              {actions.map(({ label, icon }) => (
                <div onClick={() => handleClick(label)} key={label} className={classes.item}>
                  <div className={classes.iconWrapper}>
                    <Icon icon={icon} className={classes.iconStyle} />
                  </div>
                  <span className={classes.label}>{label}</span>
                </div>
              ))}
            </div>
          </div>

          {pageLoading ? (
            <PageLoader />
          ) : (
            <div className="margin-top-16">
              {studentInRoom?.length > 0 ? (
                <Table data={searchResult} columns={recentUser} subHeader={true} pagination subHeaderComponent={
                  <TableSearch placeholder="Search here..." searchTableFunc={handleSearchInventory} />
                }
                />
              ) : (
                <div className={classes.notfound}>
                  <NoData
                    img={NoRecentUsers}
                    title="No Student in this room"
                    subtitle="No student has been added to this hostel room"
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {/* Create Hostels */}
        <Modal
          title="Create Hostels"
          subtitle={
            <div>
                Create a new hostel by filling in the details below.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Hostel Name"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="Enter Name"
                    //   onChange={handleChange}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Hostel Type(Gender)"
                    required
                    children={
                      <select name="session_id">
                        <option value="">--- Select ---</option>
                        {Gender?.map((gender) => {
                          return (
                            <option key={gender.key} value={gender?.key}>
                              {gender?.text}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Hostel Master"
                    required
                    children={
                      <select name="hostel_master">
                        <option value="">--- Select ---</option>
                        {employeesData?.map((employee) => {
                          return (
                            <option key={employee?.employee_id} value={employee?.employee_id}>
                              {`${employee?.first_name} ${employee?.last_name}`}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Number of Rooms"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="Enter rooms"
                    //   onChange={handleChange}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Room Capacity"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="Enter rooms"
                    //   onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Create Hostel"
                // onClick={handleCreateScore}
                // isLoading={scoreCreateLoading}
                />
              </div>
            </>
          }
          isopen={itemModal}
          closeModal={handleOpenItemMOdal}
        />
        {/* Allocate Hostels */}
        {/* Allocate Hostels */}
        <Modal
          title="Alocate Hostels"
          subtitle={
            <div>
                Allocate a hostel to a student by filling in the details below.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Hostel"
                    required
                    children={
                      <select disabled defaultValue={hostelRoom?.hostel_id} onChange={handleAllocateHostelChange} name="hostel_id">
                        <option value="">--- Select ---</option>
                        {allHostels?.map((hostel) => {
                          return (
                            <option key={hostel?.id} value={hostel?.id}>
                              {hostel?.name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {allocateHostelValidator.message("Hostel", allocations?.hostel_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className="multiple-select">
                    <p>Students</p>
                    <Select
                      name="students"
                      options={studentData}
                      placeholder="Select a student"
                      isMulti
                      isClearable
                      onChange={handleStudentChange}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </div>
                  {allocateHostelValidator.message("Students", allocations?.students, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Room Number"
                    required
                    children={
                      <select disabled defaultValue={hostelRoom?.id} onChange={handleAllocateHostelChange} name="room_id">
                        <option value="">--- Select ---</option>
                        {allHostelRoom?.map((room) => {
                          return (
                            <option key={room.id} value={room?.id}>
                              {room?.name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {allocateHostelValidator.message("Hostel Room", allocations?.room_id, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Allocate Hostel"
                  onClick={handleAllocateHostel}
                  isLoading={isAllocating}
                />
              </div>
            </>
          }
          isopen={allocate}
          closeModal={handleCloseAllocateModal}
        />
        {/* Edit Room Modal */}
        <Modal
          title={`Edit Room ${currentRow?.room_number}`}
          subtitle={`Edit details of Room ${currentRow?.room_number} in ${currentRow?.hostel_name} `}
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Hostel"
                    required
                    children={
                      <select disabled defaultValue={currentRow?.hostel_id}>
                        <option value="">--- Select ---</option>
                        {allHostels?.map((hostels) => {
                          return (
                            <option key={hostels?.id} value={hostels?.id}>
                              {hostels?.name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {editRoomValidator.message("Hostel Name", edithostelRoomForm?.hostel_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Room Number"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="room_number"
                    defaultValue={edithostelRoomForm?.room_number}
                    onChange={handleEditRoomChange}
                  />
                  {editRoomValidator.message("Room Number", edithostelRoomForm?.room_number, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Room Capacity"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="capacity"
                    onChange={handleEditRoomChange}
                    defaultValue={edithostelRoomForm?.capacity}
                  />
                  {editRoomValidator.message("Room Capacity", edithostelRoomForm?.capacity, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <Button
                type="submit"
                onClick={handleEditRoom}
                variant="primary"
                buttonName="Edit Hostel"
                buttonSize="full"
                color="btndefault"
                isLoading={isRoomEditing}
              />
            </>
          }
          isopen={editRoomModal}
          closeModal={handleCloseEditModal}
        />
        {/* Delete Modal */}
        <Modal
          title="Delete Room"
          subtitle={`Are you sure you want to delete ${currentRow?.room_number} in ${currentRow?.hostel_name}`}
          modalContent={
            <>
              <div>
              </div>
            </>
          }
          modalFooter={
            <>
              <Button
                type="submit"
                variant="danger"
                buttonName="Delete Room"
                buttonSize="full"
                color="btndefault"
                onClick={handleDeleteHostel}
                isLoading={isDeleting}
              />
            </>
          }
          isopen={deleteRoomModal}
          closeModal={handleCloseDeleteRoom}
        />
        {/* Delete Student Modal */}
        <Modal
          title="Remove Student"
          subtitle={`Are you sure you want to remove {" "} ${itemRow?.full_name} {" "} from {" "} ${hostelRoom?.room_number} {" "} in {" "} ${hostelRoom?.hostel_name}?`}
          modalContent={
            <>
              <div>
              </div>
            </>
          }
          modalFooter={
            <>
              <Button
                type="submit"
                variant="danger"
                buttonName="Remove Student"
                buttonSize="full"
                color="btndefault"
                onClick={handleRemoveStudent}
                isLoading={isRemoving}
              />
            </>
          }
          isopen={removeStudentModal}
          closeModal={handleCloseRemoveStudent}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default AdminHostel;
